export const pageConfig = {
  title: "مدل های ما",
  suptitle: "مدل های هوش مصنوعی",
  pay_link: "https://pay.figai.ir/",

  subscriptions: {
    "sub-pro": "اشتراک پرو",
    "sub-ultra": "اشتراک اولترا",
  } as Record<string, string>,

  detail: {
    back: "بازگشت به مدل‌ها",
    more: "جزئیات مدل",
    about_title: "درباره مدل",
    pricing_title: "هزینه استفاده",
    benchmarks_title: "بنچمارک‌ها",
    release_label: "تاریخ انتشار",
    cta_title: "شروع استفاده از",
    benchmark_labels: {
      intelligenceIndex: "شاخص هوش (Artificial Analysis)",
      codingIndex: "شاخص برنامه‌نویسی",
      agenticIndex: "شاخص عامل‌محور (Agentic)",
      gpqaDiamond: "GPQA Diamond",
      sweBenchVerified: "SWE-bench Verified",
      sweBenchPro: "SWE-bench Pro",
      humanityLastExam: "Humanity's Last Exam",
      terminalBench: "Terminal-Bench",
      terminalBenchScience: "Terminal-Bench Science",
      frontierCode: "FrontierCode",
      frontierMath: "FrontierMath",
      automationBench: "AutomationBench",
      osWorld: "OSWorld",
      deepSwe: "DeepSWE",
      cursorBench: "CursorBench",
    } as Record<string, string>,
  },

  card: {
    input_token_label: "هزینه ورودی",
    output_token_label: "هزینه خروجی",
    input_token_cost_label: "1 توکن ورودی",
    output_token_cost_label: "1 توکن خروجی",
    topup: {
      pre: "دریافت",
      tail: "تومان",
    }
  }
}

export type PageConfig = typeof pageConfig
